import gql from "graphql-tag";

export default gql`
    query CityGeoJSON($city: String, $state: String) {
        cityGeoJson(city: $city, state: $state)
    }
`;